// removed by extract-text-webpack-plugin
module.exports = {"dropText":"dropText___2JCbL","playerContainer":"playerContainer___30Iif","thumbnail":"thumbnail___2kFdZ","tabTitle":"tabTitle___19nX7","container":"container___3vn0x","title":"title___XIlUo","select":"select___3gH0T","label":"label___1iWdG","noAssets":"noAssets___2hMmw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlayerContainer/PlayerContainer.module.css
// module id = 306
// module chunks = 0